module.exports = __webpack_public_path__ + "static/media/acura-plus.0db269f7.svg";